import getters from "./getters";
import actions from "./actions";
import * as types from "./../action-types";
import browserLocation from "@/helpers/BrowserLocation";
import { cloneDeep } from "lodash";

const initialState = () =>
  cloneDeep({
    adminUser: {},
    token: {},
  });

const mutations = {
  [types.LOGIN.SUCCESS](state, { token, user, restoreBrowserLocation }) {
    state.adminUser = user;
    state.token = token;
    if (restoreBrowserLocation) browserLocation.restoreLocation();
  },
  [types.LOGIN.ERROR](state, error) {
    localStorage.clear();
    state.adminUser = {};
    state.token = {};
  },
  [types.LOGOUT.SUCCESS](state) {
    localStorage.clear();
    browserLocation.storeLocation();
    state.adminUser = {};
    state.token = {};
  },
  [types.SET_USER](state, data) {
    state.adminUser = data;
  },
};

// Add non asynchronous actions
Object.assign(actions, {});

export default {
  state: initialState(),
  mutations,
  getters,
  actions,
  namespaced: true,
};
